module.exports = __webpack_public_path__ + "media/packs/images/flags/KW-18338b437a249c0e1d77e5b811934af7.png";